module.exports = {
  siteUrl: `https://gutsy.fashion/preview`,
  siteTitle: `Gutsy`,
  siteTitleAlt: `Gutsy`,
  siteTitleShort: `Gutsy`,
  siteDescription: `Kick off your next, great Gatsby project with this starter.`,
  manifest: {
    themeColor: `#253688`,
    backgroundColor: `#253688`,
  },
  googleAnalyticsId: `UA-XXXXX`,
  facebook: `Your optional Facebook App ID`,
  twitter: `Your Twitter username`,
  schema: {
    author: `Jane Doe`,
  },
}
